import { useColorMode } from '@chakra-ui/react';
import { enUS, es, ptBR } from 'date-fns/locale';
import React from 'react';
import ReactDatePicker, {
  ReactDatePickerProps,
  registerLocale,
} from 'react-datepicker';
import { useTranslation } from 'react-i18next';

import 'react-datepicker/dist/react-datepicker.css';
import './date-picker.css';

// based on https://gist.github.com/igoro00/99e9d244677ccafbf39667c24b5b35ed

// Month/weekday names come from date-fns, so each app language needs its
// locale registered under the same code i18next reports.
const LOCALES = { pt: ptBR, en: enUS, es } as const;

Object.entries(LOCALES).forEach(([code, locale]) => {
  registerLocale(code, locale);
});

const WCDatePicker = <T extends string, R extends boolean>({
  ...props
}: ReactDatePickerProps<T, R>): JSX.Element => {
  const isLight = useColorMode().colorMode === 'light'; // you can check what theme you are using right now however you want
  const { i18n } = useTranslation();

  // i18next may report a regional code (`pt-BR`); keep only the base language.
  const language = (i18n.language || 'en').split('-')[0];
  const locale = language in LOCALES ? language : 'en';

  return (
    // if you don't want to use chakra's colors or you just wwant to use the original ones,
    // set className to "light-theme-original" ↓↓↓↓
    <div className={isLight ? 'light-theme' : 'dark-theme'}>
      <ReactDatePicker
        className="react-datapicker__input-text" // input is white by default and there is no already defined class for it so I created a new one
        locale={locale}
        {...props}
        dateFormat={props.dateFormat || 'dd/MM/yyyy'}
      />
    </div>
  );
};

export default WCDatePicker;
